export class UcBlockableElementInitializedEvent extends Event {

  ucService: string
  ucId: string
  useBasicThumbnail: boolean

  constructor (ucId: string, ucService: string, useBasicThumbnail?: boolean) {
    super('ucBlockableElementInitialized')
    this.ucService = ucService
    this.ucId = ucId
    this.useBasicThumbnail = useBasicThumbnail || false
  }
}
